export class IngestContainerModel {
  constructor(public sasToken: string, public containerName: string) { }
}
